import React from 'react';
import { Navbar, Button } from 'react-bootstrap';

interface HeaderProps {
  onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({ onLogout }) => {
  return (
    <Navbar className="navbar-expand-lg dashboard-header">
      <div className="container-fluid">
        <div style={{ fontSize: '1.6rem', margin: 0, color: 'white', fontWeight: 600 }}>
          <i className="bi bi-globe"></i> Haber Yazılımı Demo Site Oluşturucu
        </div>
        <div className="ms-auto">
          <Button variant="outline-light" size="sm" onClick={onLogout}>
            <i className="bi bi-box-arrow-right"></i> Çıkış
          </Button>
        </div>
      </div>
    </Navbar>
  );
};

export default Header;